import { types } from "./notificationOccurrence.actions";
import { Reducer } from "../../services/reducer.factory";


const initialState = {
  columnsSelectionRecords: [
    {
      field: "description",
      header: "Ocorrências selecionadas",
      columnKey: "oid",
      sortable: false,
      filter: true
    },
    {
      field: "action",
      header: "Ação",
      columnKey: "action",
      sortable: false,
      filter: false
    },
  ],
  columns: [
    {
      field: "oid",
      header: "Código",
      columnKey: "oid",
      sortable: false,
      filter: true
    },
    {
      field: "phoneWhatsApp",
      header: "Número WhatsApp",
      columnKey: "phoneWhatsApp",
      sortable: false,
      filter: true
    },
    {
      field: "email",
      header: "E-mail",
      columnKey: "email",
      sortable: false,
      filter: true
    },
    {
      field: "useWhatsAppNotification",
      header: "WhatsApp",
      columnKey: "useWhatsAppNotification",
      sortable: false,
      filter: false
    },
    {
      field: "useEmailNotification",
      header: "e-mail",
      columnKey: "useEmailNotification",
      sortable: false,
      filter: false
    },
  ],
  
  
  currentRecord: {
    phoneWhatsApp: "",
    email: "",
    useWhatsAppNotification: false,
    useEmailNotification: false,
    notificationOccurrences: [],
  },
  lookupOccurrenceType: {
    visible: false,
    modal: false
  },
  occurrenceTypeFilter: [],
  useWhatsAppNotification: false,
  useEmailNotification: false,
  selectedRecords: [],
  records: []
}

const reducer = new Reducer(initialState, types);

export function CRUDNotificationOccurrenceReducer(state, action) {
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    case types.SET_LOOKUP_OCCURENCE_TYPE_VISIBLE:
      return setlookupOccurrenceTypeVisible(state, action);
    case types.SET_FIELD_OCCURRENCE_TYPE_FILTER:
      return setFieldOccurrenceTypeFilter(state, action);
    case types.SET_SELECTED_RECORDS:
      return setSelectedRecords(state, action)
    default:
      return result;
  }
}
function setlookupOccurrenceTypeVisible(state, action) {
  let lookupOccurrenceType = state.lookupOccurrenceType
  lookupOccurrenceType.visible = action.visible
  state = { ...state, lookupOccurrenceType }
  return state;
}
function setFieldOccurrenceTypeFilter(state, action) {
  let occurrenceTypeFilter = state.occurrenceTypeFilter;
  occurrenceTypeFilter.push(action.fieldValue);
  // occurrenceTypeFilter = action.fieldValue;
  return { ...state, occurrenceTypeFilter };
}
function setSelectedRecords(state, action) {
  let currentRecord = state.currentRecord
  currentRecord.notificationOccurrences = action.selectedRecords
  return { ...state, currentRecord }
}